import { configureStore } from "@reduxjs/toolkit";
import mentorBookmarksReducer from "../stores/bookmarks/mentorBookmarksSlice";
import resourceBookmarksReducer from "../stores/bookmarks/resourceBookmarksSlice";
import mentorRecommendationsReducer from "../stores/recommendations/mentorRecommendationsSlice";
import sessionReducer from "../stores/sessionData/sessionDataSlice";
import userReducer from "../stores/user/userSlice";
import notificationsReducer from "../stores/notifications/notificationsSlice";
import {
  type TypedUseSelectorHook,
  useDispatch,
  useSelector,
} from "react-redux";
import { bookmarkListenerMiddleware } from "../stores/bookmarks/bookmarkListeners";
import { mentorRecommendationListenerMiddleware } from "../stores/recommendations/mentorRecommendationListeners";
import { sessionListenerMiddleware } from "../stores/sessionData/sessionDataListeners";
import { userListenerMiddleware } from "../stores/user/userListeners";

export const store = configureStore({
  reducer: {
    mentorBookmarks: mentorBookmarksReducer,
    resourceBookmarks: resourceBookmarksReducer,
    notifications: notificationsReducer,
    mentorRecommendations: mentorRecommendationsReducer,
    session: sessionReducer,
    user: userReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      mentorRecommendationListenerMiddleware.middleware,
      bookmarkListenerMiddleware.middleware,
      sessionListenerMiddleware.middleware,
      userListenerMiddleware.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
